import React from 'react'
import { Add, CloseCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Menu from '../Menu'
import useStyles, { StyledButton } from './styles'

interface AddConvoButtonProps {
  options: object
  handleSelect: (option: string) => void
}

const AddConvoButton: React.FC<AddConvoButtonProps> = ({
  options = {},
  handleSelect
}) => {
  const theme = useTheme()

  const [menuOpen, setMenuOpen] = React.useState(false)

  const classes = useStyles()

  const opts = Object.keys(options)

  if (opts.length === 1) {
    return (
      <StyledButton onClick={() => handleSelect(opts[0])}>
        <Add size={theme.size.lg} />
      </StyledButton>
    )
  }

  return (
    <Menu
      hideHeader
      closeOnClick
      menuProps={{
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        transformOrigin: { vertical: 'top', horizontal: 'left' }
      }}
      optionsComponent={opts.map((opt, i) => {
        const Icon = options[opt]

        return (
          <div
            key={i}
            onClick={() => handleSelect(opt)}
            className={classes.menuItem}
          >
            <Icon className={classes.menuIcon} />

            {opt}
          </div>
        )
      })}
      onVisibilityChange={setMenuOpen}
      menuClassName={classes.menu}
    >
      <StyledButton>
        {menuOpen ? (
          <CloseCircle size={theme.size.base} />
        ) : (
          <Add size={theme.size.base} />
        )}
      </StyledButton>
    </Menu>
  )
}

export default AddConvoButton
